module.exports = __webpack_public_path__ + "img/SD.77797017.svg";